import messages from '../../../locale/jsonMessages';
import { andValidation, colonValidation, questionValidation } from '../../../helpers/regexHelper';
import { inputTextLimit } from '../../../helpers/fieldRestriction';

const validate = (values, props) => {
  const errors = {};
  const activeLanguageCodes = props?.activeLanguageCodes || [];

  let colonUrlValidation1, questionValidation1, andValidation1, colonUrlValidation2, questionValidation2, andValidation2;

  colonUrlValidation1 = (!colonValidation.test(values?.buttonLink1));
  questionValidation1 = (values?.buttonLink1?.match(questionValidation))?.length;
  andValidation1 = (values?.buttonLink1?.match(andValidation))?.length;

  colonUrlValidation2 = (!colonValidation.test(values?.buttonLink2));
  questionValidation2 = (values?.buttonLink2?.match(questionValidation))?.length;
  andValidation2 = (values?.buttonLink2?.match(andValidation))?.length;

  if (!values?.buttonLink1) {
    errors.buttonLink1 = messages.required;
  } else if (questionValidation1 >= 1 || andValidation1 >= 1 || colonUrlValidation1) {
    errors.buttonLink1 = messages.invalidPageUrl;
  }

  if (!values?.buttonLink2) {
    errors.buttonLink2 = messages.required;
  } else if (questionValidation2 >= 1 || andValidation2 >= 1 || colonUrlValidation2) {
    errors.buttonLink2 = messages.invalidPageUrl;
  }

  if (values?.dynamicImageBanner && values.dynamicImageBanner.length > 0) {
    const dynamicImageBannerErrors = values.dynamicImageBanner.map(item => {
      const itemErrors = {};

      const isLanguageInactive = item?.language && activeLanguageCodes.length > 0
        && !activeLanguageCodes.includes(item.language);

      if (!item?.language || item?.language.toString().trim() === '' || isLanguageInactive) {
        itemErrors.language = messages.required;
      }

      if (!item?.title) {
        itemErrors.title = messages.required;
      } else if (item.title.trim() === '') {
        itemErrors.title = messages.required;
      } else if (item.title.length > inputTextLimit) {
        itemErrors.title = messages.inputTextLimitError;
      }

      if (!item?.buttonLabel) {
        itemErrors.buttonLabel = messages.required;
      } else if (item.buttonLabel.trim() === '') {
        itemErrors.buttonLabel = messages.required;
      } else if (item.buttonLabel.length > inputTextLimit) {
        itemErrors.buttonLabel = messages.inputTextLimitError;
      }

      if (!item?.buttonLabel2) {
        itemErrors.buttonLabel2 = messages.required;
      } else if (item.buttonLabel2.trim() === '') {
        itemErrors.buttonLabel2 = messages.required;
      } else if (item.buttonLabel2.length > inputTextLimit) {
        itemErrors.buttonLabel2 = messages.inputTextLimitError;
      }

      return itemErrors;
    });

    if (dynamicImageBannerErrors.some(item => Object.keys(item).length > 0)) {
      errors.dynamicImageBanner = dynamicImageBannerErrors;
    }
  }

  return errors;
};

export default validate;